import { get } from 'lodash-es';

const byResidentialHits = (state: any) =>
  get(state, 'properties.residentialHits');

export default byResidentialHits;
